/**
 * Feature Flags
 *
 * Build-time feature flags. Flip a flag to `true` to re-enable a feature
 * that is hidden from the UI while still under development.
 */

const FEATURE_FLAGS = {
  /** Obstructions artifact (tabs, map layer, panels, routing, context menu). */
  OBSTRUCTIONS: false,
} as const;

/**
 * Per-artifact gate consumed by the artifact registry. Returns whether an
 * artifact is currently enabled in the UI; unknown artifacts default to
 * enabled so only explicitly flagged features are hidden.
 */
export function isArtifactEnabled(artifactId: string): boolean {
  if (artifactId === 'obstructions') return FEATURE_FLAGS.OBSTRUCTIONS;
  return true;
}
